import "./list.scss";

import Datatable from "../../components/datatable/Datatable";

const List = () => {
	return (
		<div className="list">
			<div className="listContainer">
				<Datatable />
			</div>
		</div>
	);
};

export default List;
